import React from 'react';
import {
    Button,
    Flex,
    PriorityIcon,
    withDropdownContext
} from '@priority-software/priority-style-react';
import texts from '../text';
import styles from '../styles/selectList.module.scss';

export const ModalFooter = withDropdownContext(
    ({dropdownContext, handleAccept, handleClose, handleShowHelpMessage, helpButtonRef}: any) => (
        <Flex justifyContent="space-between" componentClasses={styles.footer}>
            <Flex justifyContent="flex-start">
                <Button
                    componentClasses={styles.acceptButton}
                    onClick={handleAccept}
                    size="large"
                    skin="primary"
                >
                    {texts.ok}
                </Button>
                <Button onClick={handleClose} name="cancel" size="large" skin="secondary">
                    {texts.cancel}
                </Button>
            </Flex>
            <Button
                onClick={() => handleShowHelpMessage(dropdownContext.focusedItem)}
                prefixIcon={PriorityIcon.questionCircle}
                // check textColor grey
                size="large"
                skin="text"
                name="help"
                inputRef={helpButtonRef}
            >
                {texts.help}
            </Button>
        </Flex>
    )
);
